import $ from 'jquery';

import {ExternalFile, ExternalFileExcerpt} from 'notebook/util/NoteUtilConstants';
import * as net from 'util/Net';
import * as TaskRunner from 'util/TaskRunner';

export interface SignURLResponse {
  signedURL: string;
}

export function uploadFile(file: File): JQueryPromise<ExternalFile> {
  const formData = new FormData();
  formData.append(file.name, file, file.name);
  return $.ajax({
    type: 'POST',
    url: '/1/api/external-files/',
    data: formData,
    processData: false,
    contentType: false,
  }).then((res) => res[0]);
}

export function update(
  externalFileId: string,
  data: ExternalFileExcerpt
): JQueryPromise<ExternalFileExcerpt> {
  return net.patchJSON({
    url: `/1/api/external-files/${externalFileId}`,
    data,
  });
}

export function fetchExcerpts(
  externalFileId: string,
  enhanceOffsets: Array<number> = [],
  recompute: boolean = false
): Promise<Array<ExternalFileExcerpt>> {
  return TaskRunner.postJSONPromise({
    url: `/1/api/external-files/${externalFileId}/excerpts`,
    data: {
      recompute,
      enhanceOffsets,
    },
  });
}
